import * as moment from 'moment';
import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { changeCompanyData, ChangeCompanyDataAction } from 'src/actions/company/change-data/ChangeCompanyData.actions';
import * as updateCompanyTypes from 'src/actions/company/update/Types';
import {
  UpdateCompanyAction,
  updateCompanyClearErrors,
  updateCompanyContactInformation,
  UpdateCompanySuccess
} from 'src/actions/company/update/UpdateCompany.actions';
import Project from 'src/entities/Project';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import { RootState } from 'src/reducers/RootReducer';
import CompanyData from 'src/value-objects/CompanyData';
import ProjectContactInformationFormComponent from './ProjectContactInformationForm.component';

interface StateProps {
  formData?: CompanyData;
  error: boolean;
  errorMessage: {};
}

interface DispatchProps {
  updateCompanyClearErrors(): UpdateCompanyAction;
  changeCompanyData(company: CompanyData): ChangeCompanyDataAction;
  updateCompanyContactInformation(company: CompanyData): Promise<UpdateCompanyAction>;
}

interface Props extends StateProps, DispatchProps {
  project: Project;
}

interface State {
  success?: boolean;
}

class ProjectContactInformationFormContainer extends React.PureComponent<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {};
    this.props.updateCompanyClearErrors();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public componentWillMount(): void {
    this.props.changeCompanyData(new CompanyData(this.props.project.company));
    this.setState(
      { success: false }
    );
  }

  public render(): React.ReactNode {
    return (
      this.props.project && this.props.formData ?
        (
          <ProjectContactInformationFormComponent
            formData={this.props.formData!}
            error={this.props.error}
            errorMessage={this.props.errorMessage}
            success={this.state.success!}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
        ) :
        <LoadingContainer />
    );
  }

  private handleChange(key: string): (value: string | boolean | File | moment.Moment) => void {
    switch (key) {
      case 'contactBirthDate':
        return (value: moment.Moment) => {
          this.props.formData!.contactBirthDate = value;
          this.props.changeCompanyData(new CompanyData(this.props.formData!));
        };
      default:
        return (value: string | boolean) => {
          let newData = { ...this.props.formData!, [key]: value };
          this.props.changeCompanyData(new CompanyData(newData));
        };
    }
  }

  private handleSubmit(): void {
    this.props.updateCompanyContactInformation(this.props.formData!).then((response: UpdateCompanySuccess) => {
      if (response.type === updateCompanyTypes.UPDATE_COMPANY_SUCCESS) {
        this.setState(
          { success: true }
        );
      }
    });
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
    changeCompanyData: (company: CompanyData): ChangeCompanyDataAction => (
      dispatch(changeCompanyData(company))
    ),
    updateCompanyContactInformation: (company: CompanyData): Promise<UpdateCompanyAction> => (
      dispatch(updateCompanyContactInformation(company))
    ),
    updateCompanyClearErrors: (): UpdateCompanyAction => {
      return dispatch(updateCompanyClearErrors());
    }
  });

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  formData: state.changeCompanyData.company,
  error: state.updateCompany.error,
  errorMessage: state.updateCompany.errorMessage,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectContactInformationFormContainer);



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/ProjectContactInformationForm.container.tsx